import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_163: DocMigration = {
  maxSchemaVersion: "0.0.163",
  description: "New annotation type (structural)",
  apply(json: any) {
    const { viewerFilter } = json;
    if (viewerFilter) {
      viewerFilter["annotationStructuralPlan"] = true;
    }

    return json;
  },
};

export default migration_0_0_163;
